(function($) {
  $('#bc-search').on('submit', function() {
      var term = $(this).find('input[type="search"]').val().replaceAll(/ /g, '+');
      window.location.href = `https://burnaby.bibliocommons.com/v2/search?query=${term}&searchType=smart`;
      return false;
  });
})(jQuery);